/** @jsx React.createElement */
/** @jsxFrag React.Fragment */
import * as React from 'react';

import {SpinnerReact} from 'common/components/spinner';

import {BarPreview} from './charts/bar';
import {ChartPreviewCarousel} from './chart-preview-carousel';
import {FunnelPreview} from './charts/funnel';
import {LinePreview} from './charts/line';
import {BarBreakdownPreview} from './charts/bar-breakdown';
import {StackedBarBreakdownPreview} from './charts/stacked-bar-breakdown';
import {FunnelBreakdownPreview} from './charts/funnel-breakdown';

const CHART_PREVIEW_MAX = 4;

export const EventChartPreviewCarousel = ({events}) => {
  if (!events || events.length === 0) {
    return <SpinnerReact />;
  }

  const eventsToShow = events.slice(0, CHART_PREVIEW_MAX);

  return (
    <ChartPreviewCarousel>
      <FunnelPreview events={eventsToShow} />
      <LinePreview events={eventsToShow} />
      <BarPreview events={eventsToShow} />
    </ChartPreviewCarousel>
  );
};

export const PropertyBreakdownPreviewCarousel = ({events, property}) => {
  if (!events || events.length === 0) {
    return <SpinnerReact />;
  }

  const eventsToShow = events.slice(0, CHART_PREVIEW_MAX);

  return (
    <ChartPreviewCarousel>
      <FunnelBreakdownPreview events={eventsToShow} property={property} />
      <StackedBarBreakdownPreview events={eventsToShow} property={property} />
      <BarBreakdownPreview events={eventsToShow} property={property} />
    </ChartPreviewCarousel>
  );
};
